const releasesValidationES = {
    "add": {
        "releaseName": {
            "required": 'El nombre del lanzamiento es obligatorio',
            "length": 'El nombre del lanzamiento debe tener más de 2 y menos de 120 caracteres',
            "noForwardSlash": 'El nombre del lanzamiento no debe tener ninguna barra inclinada (/)',
            "matchTrack": 'Para un lanzamiento de una sola canción, el nombre del lanzamiento debe coincidir con la pista.',
            // validCharacters: 'El nombre del lanzamiento solo puede consistir en letras, números, espacios y guiones bajos'
            },
            "releaseVersion": {
                "length": 'La versión del lanzamiento debe tener más de 2 y menos de 120 caracteres',
                "validCharacters": 'La versión del lanzamiento solo puede consistir en letras, números, espacios y guiones bajos',
                "missingOne": 'Tu lanzamiento consta de solo una pista que no es una Mezcla Original, por lo tanto, el nombre de la mezcla personalizada debe insertarse en la Versión del Lanzamiento.',
                "missingTwo": 'Si un lanzamiento ofrece más contenido que la versión estándar o es otra versión de un álbum/lanzamiento ya publicado, debes insertar la Versión del Lanzamiento.',
                "invalid": 'Para un lanzamiento de una sola canción sin Nombre de Mezcla (Mezcla Original), la Versión del Lanzamiento debe dejarse vacía. Por favor, limpia la Versión del Lanzamiento o agrega un Nombre de Mezcla a la canción.'
            },
            "releaseLanguage": {
                "required": 'El idioma del lanzamiento es obligatorio. Por favor, selecciona el idioma del nombre de tu lanzamiento.'
            },
            "releaseEAN_UPC": {
                "required": "Se requiere EAN / UPC.",
                "length": "El número EAN debe tener exactamente 13 caracteres.",
                "isValidEAN": "El valor no es un EAN válido. Si estás ingresando un nuevo lanzamiento, por favor introduce un EAN correcto. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos."
            },
            "releaseLabel": {
                "required": 'Por favor, selecciona tu sello.'
            },
            "releaseCopyright": {
                "required": 'Debes escribir el Propietario de los Derechos de Autor. Usualmente es tu sello.'
            },
            "releaseCopyrightYear": {
                "required": 'Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.',
                "regexp": 'Por favor, escribe un año de derechos de autor válido'
            },
            "releaseCopyrightPublisher": {
                "required": 'Debes escribir el Propietario del Editor. Usualmente es tu sello.'
            },
            "releaseCopyrightYearPublisher": {
                "required": 'Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.',
                "regexp": 'Por favor, escribe un año de derechos de autor válido'
            },
            "releaseGenre": {
                "required": 'Por favor, selecciona el Género de tu lanzamiento.'
            },
            "releaseSubGenre": {
                "required": 'Por favor, selecciona el Sub-Género de tu lanzamiento'
            },
            "releaseCatalogNumber": {
                "required": 'Inserta un número de catálogo único para el lanzamiento.',
                "length": 'Mínimo 4 y Máximo 16 caracteres.',
                "validFormat": 'Por favor, inserta tu número de categoría sin espacios, solo letras MAYÚSCULAS y números. Los primeros dos caracteres deben ser letras MAYÚSCULAS. MM001, MMD001, MM0001 ... '
            },
            "releaseDescription": {
                // required: 'Una buena y profesional descripción del lanzamiento puede marcar la diferencia.',
                "length": 'Una descripción del lanzamiento debe tener al menos 100 y como máximo 600 caracteres.'
            },
            "releaseArtwork": {
                "required": 'La obra de arte es obligatoria',
                "wrongSpecsAndColor": 'Especificaciones de imagen y formato de color incorrectos. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px, Colores RGB, JPG, Tamaño máximo de archivo 4 MB.',
                "wrongColorFormat": 'Formato de color de imagen incorrecto. La portada del lanzamiento debe estar en Colores RGB. JPG, Tamaño máximo de archivo 4 MB.',
                "wrongSpecs": 'Especificaciones de imagen incorrectas. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px. JPG, Tamaño máximo de archivo 4 MB.',
                "meetsSpecs": 'La imagen cumple con todas las especificaciones.',
                "chooseImage": 'Por favor, elige una imagen',
                "fileTooLarge": 'El archivo seleccionado es mayor de 4 MB. Por favor, sube la portada en 3000x3000 px, JPG, colores RGB, tamaño máximo de archivo 4 MB',
                "wrongExtension": 'Extensión de archivo incorrecta. El archivo seleccionado tiene la extensión ".jpeg". Por favor, sube la portada en 3000x3000 px, JPG (solo extensión ".jpg"), colores RGB, tamaño máximo de archivo 4 MB'
            },
            "releaseTerritories": {
                "required": 'Por favor, selecciona territorios.'
            },
            "atleastOneCountrySelected": {
                "required": 'Por favor, selecciona al menos un país.'
            },
            "atleastOneContentIDChoiceSelected": {
                "required": 'La declaración de ID de Contenido de Youtube es obligatoria, por favor selecciona una de las opciones anteriores.'
            },
            "originalReleaseDate": {
                "required": 'Por favor, selecciona la fecha de lanzamiento original para todas las tiendas en todo el mundo.'
            },
            "officialReleaseDate": {
                "required": 'Por favor, selecciona la fecha de lanzamiento oficial para todas las tiendas en todo el mundo.'
            },
            "atleastOneMainArtist": {
                "required": 'Al menos un artista debe ser principal'
            },
            "featuringArtistMissing": {
                "required": 'El lanzamiento debe tener el artista destacado listado en el título correctamente asignado como artista destacado. Por favor, corrige y vuelve a enviar.'
            },
            "duplicateArtists": {
                "required": 'Hay dos o más artistas con el mismo nombre.'
            },
            "artistName": {
                "required": 'Por favor, selecciona artista'
            },
            "artistType": {
                "required": 'Por favor, selecciona tipo de artista'
            },
            "trackName": {
                "required": 'Por favor, escribe el nombre de la pista'
            },
            "trackMixName": {
                "required": 'Por favor, escribe el nombre de la mezcla',
                "regexp": 'El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos'
            }
    },
    "update": {
        "releaseName": {
            "required": 'El nombre del lanzamiento es obligatorio',
            "length": 'El nombre del lanzamiento debe tener más de 2 y menos de 120 caracteres',
            "noForwardSlash": 'El nombre del lanzamiento no debe tener ninguna barra inclinada (/)',
            "matchTrack": 'Para un lanzamiento de una sola canción, el nombre del lanzamiento debe coincidir con la pista.',
            "validCharacters": 'El nombre del lanzamiento solo puede consistir en letras, números, espacios y guiones bajos'
        },
        "releaseVersion": {
            "length": 'La versión del lanzamiento debe tener más de 2 y menos de 120 caracteres',
            "validCharacters": 'La versión del lanzamiento solo puede consistir en letras, números, espacios y guiones bajos',
            "missingOne": 'Tu lanzamiento consta de solo una pista que no es una Mezcla Original, por lo tanto, el nombre de la mezcla personalizada debe insertarse en la Versión del Lanzamiento.',
            "missingTwo": 'Si un lanzamiento ofrece más contenido que la versión estándar o es otra versión de un álbum/lanzamiento ya publicado, debes insertar la Versión del Lanzamiento.',
            "invalid": 'Para un lanzamiento de una sola canción sin Nombre de Mezcla (Mezcla Original), la Versión del Lanzamiento debe dejarse vacía. Por favor, limpia la Versión del Lanzamiento o agrega un Nombre de Mezcla a la canción.'
        },
        "releaseLanguage": {
            "required": 'El idioma del lanzamiento es obligatorio. Por favor, selecciona el idioma del nombre de tu lanzamiento.'
        },
        "releaseEAN_UPC": {
            "required": "Se requiere EAN / UPC.",
            "length": "El número EAN debe tener exactamente 13 caracteres.",
            "isValidEAN": "El valor no es un EAN válido. Si estás ingresando un nuevo lanzamiento, por favor introduce un EAN correcto. Si estás subiendo un catálogo anterior y el EAN no es válido, por favor contáctanos."
        },
        "releaseLabel": {
            "required": 'Por favor, selecciona tu sello.'
        },
        "releaseCopyright": {
            "required": 'Debes seleccionar el Propietario de los Derechos de Autor. Usualmente es tu sello.'
        },
        "releaseCopyrightYear": {
            "required": 'Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.',
            "regexp": 'Por favor, escribe un año de derechos de autor válido'
        },
        "releaseCopyrightPublisher": {
            "required": 'Debes escribir el Propietario del Editor. Usualmente es tu sello.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.',
            "regexp": 'Por favor, escribe un año de derechos de autor válido'
        },
        "releaseGenre": {
            "required": 'Por favor, selecciona el Género de tu lanzamiento.'
        },
        "releaseSubGenre": {
            "required": 'Por favor, selecciona el Sub-Género de tu lanzamiento'
        },
        "releaseCatalogNumber": {
            "required": 'Inserta un número de catálogo único para el lanzamiento.',
            "length": 'Mínimo 4 y Máximo 16 caracteres.',
            "validFormat": 'Por favor, inserta tu número de categoría sin espacios, solo letras MAYÚSCULAS y números. Los primeros dos caracteres deben ser letras MAYÚSCULAS. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'Una descripción del lanzamiento debe tener al menos 100 y como máximo 600 caracteres.'
        },
        "releaseArtwork": {
            "required": 'La obra de arte es obligatoria',
            "wrongSpecsAndColor": 'Especificaciones de imagen y formato de color incorrectos. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px, Colores RGB, JPG, Tamaño máximo de archivo 4 MB.',
            "wrongColorFormat": 'Formato de color de imagen incorrecto. La portada del lanzamiento debe estar en Colores RGB. JPG, Tamaño máximo de archivo 4 MB.',
            "wrongSpecs": 'Especificaciones de imagen incorrectas. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px. JPG, Tamaño máximo de archivo 4 MB.',
            "meetsSpecs": 'La imagen cumple con todas las especificaciones.',
            "chooseImage": 'Por favor, elige una imagen',
            "fileTooLarge": 'El archivo seleccionado es mayor de 4 MB. Por favor, sube la portada en 3000x3000 px, JPG, colores RGB, tamaño máximo de archivo 4 MB',
            "wrongExtension": 'Extensión de archivo incorrecta. El archivo seleccionado tiene la extensión ".jpeg". Por favor, sube la portada en 3000x3000 px, JPG (solo extensión ".jpg"), colores RGB, tamaño máximo de archivo 4 MB'
        },
        "releaseTerritories": {
            "required": 'Por favor, selecciona territorios.'
        },
        "atleastOneCountrySelected": {
            "required": 'Por favor, selecciona al menos un país.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'La declaración de ID de Contenido de Youtube es obligatoria, por favor selecciona una de las opciones anteriores.'
        },
        "originalReleaseDate": {
            "required": 'Por favor, selecciona la fecha de lanzamiento original para todas las tiendas en todo el mundo.'
        },
        "officialReleaseDate": {
            "required": 'Por favor, selecciona la fecha de lanzamiento oficial para todas las tiendas en todo el mundo.'
        },
        "atleastOneMainArtist": {
            "required": 'Al menos un artista debe ser principal'
        },
        "featuringArtistMissing": {
            "required": 'El lanzamiento debe tener el artista destacado listado en el título correctamente asignado como artista destacado. Por favor, corrige y vuelve a enviar.'
        },
        "duplicateArtists": {
            "required": 'Hay dos o más artistas con el mismo nombre.'
        },
        "artistName": {
            "required": 'Por favor, selecciona artista'
        },
        "artistType": {
            "required": 'Por favor, selecciona tipo de artista'
        },
        "trackName": {
            "required": 'Por favor, escribe el nombre de la pista'
        },
        "trackMixName": {
            "required": 'Por favor, escribe el nombre de la mezcla',
            "regexp": 'El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos'
        }
    },
    "transfer": {
        "releaseName": {
            "required": "El nombre del lanzamiento es obligatorio",
            "length": "El nombre del lanzamiento debe tener entre 2 y 120 caracteres",
            "invalid": "El nombre del lanzamiento no puede contener una barra inclinada (/)"
        },
        "releaseVersion": {
            "length": "La versión del lanzamiento debe tener más de 2 y menos de 120 caracteres",
            "regexp": "La versión del lanzamiento solo puede consistir en letras, números, espacios y guiones bajos",
            "missingOne": "Tu lanzamiento consta de solo una pista que no es una Mezcla Original, por lo tanto, el nombre de la mezcla personalizada debe insertarse en la Versión del Lanzamiento.",
            "missingTwo": "Si un lanzamiento ofrece más contenido que la versión estándar o es otra versión de un álbum/lanzamiento ya publicado, debes insertar la Versión del Lanzamiento.",
            "invalid": "Para un lanzamiento de una sola canción sin Nombre de Mezcla (Mezcla Original), la Versión del Lanzamiento debe dejarse vacía. Por favor, limpia la Versión del Lanzamiento o agrega un Nombre de Mezcla a la canción."
        },
        "releaseLanguage": {
            "required": "El idioma del lanzamiento es obligatorio. Por favor, selecciona el idioma del nombre de tu lanzamiento."
        },
        "releaseLabel": {
            "required": "Por favor, selecciona tu sello."
        },
        "releaseCopyright": {
            "required": "Debes escribir el Propietario de los Derechos de Autor. Usualmente es tu sello."
        },
        "releaseCopyrightYear": {
            "required": "Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.",
            "regexp": "Por favor, escribe un año de derechos de autor válido"
        },
        "releaseCopyrightPublisher": {
            "required": "Debes escribir el Propietario del Editor. Usualmente es tu sello."
        },
        "releaseCopyrightYearPublisher": {
            "required": "Por favor, escribe el año de derechos de autor en el que este lanzamiento será (fue) publicado.",
            "regexp": "Por favor, escribe un año de derechos de autor válido"
        },
        "releaseGenre": {
            "required": "Por favor, selecciona el Género de tu lanzamiento."
        },
        "releaseSubGenre": {
            "required": "Por favor, selecciona el Sub-Género de tu lanzamiento."
        },
        "releaseCatalogNumber": {
            "required": "Inserta un número de catálogo único para el lanzamiento.",
            "length": "Mínimo 4 y Máximo 16 caracteres.",
            "regexp": "Por favor, inserta tu número de categoría sin espacios, solo letras MAYÚSCULAS y números. Los primeros dos caracteres deben ser letras MAYÚSCULAS. MM001, MMD001, MM0001 ... "
        },
        "releaseDescription": {
            "length": "Una descripción del lanzamiento debe tener al menos 100 y como máximo 600 caracteres."
        },
        "releaseArtwork": {
            "required": "La obra de arte es obligatoria",
            "invalidDimensionsAndColorFormat": "Especificaciones de imagen y formato de color incorrectos. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px, Colores RGB, JPG, Tamaño máximo de archivo 4 MB.",
            "invalidColorFormat": "Formato de color de imagen incorrecto. La portada del lanzamiento debe estar en Colores RGB. JPG, Tamaño máximo de archivo 4 MB.",
            "invalidDimensions": "Especificaciones de imagen incorrectas. El tamaño de la portada del lanzamiento debe ser exactamente 3000 x 3000 px. JPG, Tamaño máximo de archivo 4 MB.",
            "valid": "La imagen cumple con todas las especificaciones",
            "choose": "Por favor, elige una imagen",
            "fileSize": "El archivo seleccionado es mayor de 4 MB. Por favor, sube la portada en 3000x3000 px, JPG, colores RGB, tamaño máximo de archivo 4 MB",
            "fileExtension": "Extensión de archivo incorrecta. El archivo seleccionado tiene la extensión '.jpeg'. Por favor, sube la portada en 3000x3000 px, JPG (solo extensión '.jpg'), colores RGB, tamaño máximo de archivo 4 MB'"
        },
        "releaseTerritories": {
            "required": "Por favor, selecciona territorios."
        },
        "atleastOneCountrySelected": {
            "required": "Por favor, selecciona al menos un país."
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "La declaración de ID de Contenido de Youtube es obligatoria, por favor selecciona una de las opciones anteriores."
        },
        "originalReleaseDate": {
            "required": "Por favor, selecciona la fecha de lanzamiento original para todas las tiendas en todo el mundo."
        },
        "officialReleaseDate": {
            "required": "Por favor, selecciona la fecha de lanzamiento oficial para todas las tiendas en todo el mundo."
        },
        "atleastOneMainArtist": {
            "required": "Al menos un artista debe ser principal"
        },
        "artistType": {
            "required": "Por favor, selecciona tipo de artista"
        },
        "trackName": {
            "required": "Por favor, escribe el nombre de la pista"
        },
        "trackMixName": {
            "required": "Por favor, escribe el nombre de la mezcla",
            "regexp": "El nombre de la mezcla solo puede consistir en letras, números, espacios y guiones bajos"
        }
    }
};

export default releasesValidationES;